import { render, staticRenderFns } from "./customize-report.vue?vue&type=template&id=59b746a8&scoped=true"
import script from "./customize-report.vue?vue&type=script&lang=js"
export * from "./customize-report.vue?vue&type=script&lang=js"
import style0 from "./customize-report.vue?vue&type=style&index=0&id=59b746a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b746a8",
  null
  
)

export default component.exports